import { render, staticRenderFns } from "./SettingsPaymentPayoneer.vue?vue&type=template&id=746c554f&lang=pug&"
import script from "./SettingsPaymentPayoneer.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentPayoneer.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPaymentPayoneer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('746c554f')) {
      api.createRecord('746c554f', component.options)
    } else {
      api.reload('746c554f', component.options)
    }
    module.hot.accept("./SettingsPaymentPayoneer.vue?vue&type=template&id=746c554f&lang=pug&", function () {
      api.rerender('746c554f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayment/SettingsPaymentPayoneer.vue"
export default component.exports